import {ScrollView, useWindowDimensions} from 'react-native';
import {useFolder} from '../../hooks/useFolder';
import {FolderType} from '../../types';
import DragList, {
  DragListRenderItemInfo,
} from 'react-native-draglist';
import {Chip, Divider, IconButton, List} from 'react-native-paper';
import {IShopConfig} from '../../types/shop';
import {
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';
import {RootStackName, ShopStackParams} from '../../types/nav';

import uuid from 'react-native-uuid';
import {useMutation} from 'react-query';
import {genMnemonic, writeItem} from '../../api';
import {networks} from '../../api/exchange';

const folderType = FolderType.shop;

export function ShopsList() {
  const navigation = useNavigation<NavigationProp<ShopStackParams>>();
  const {height} = useWindowDimensions();
  const {folderContent, onReordered, folderContentQuery} = useFolder(
    'shops',
    undefined,
    undefined,
    folderType,
  );
  const createShop = useMutation(
    async () => {
      const network = networks[window.ethereum.networkVersion];
      const shop = {
        id: uuid.v4().toString(),
        network,
        folderId: 'shops',
        folderType,
        mnemonic: genMnemonic(),
      };
      await writeItem(shop);
    },
    {onSuccess: () => folderContentQuery.refetch()},
  );
  const renderContent = (
    info: DragListRenderItemInfo<IShopConfig>,
  ) => (
    <>
      <List.Item
        title={info.item.title || info.item.id}
        description={
          <Chip icon={'ethereum'}>
            {info.item.network?.chainName}
          </Chip>
        }
        onPress={() =>
          navigation.navigate(RootStackName, {
            screen: 'ShopTab',
            params: {
              screen: 'Shop',
              params: {
                shopId: info.item.id,
                mnemonic: info.item.mnemonic,
              },
            },
          })
        }
      />
      <Divider />
    </>
  );
  return (
    <ScrollView>
      <List.Item
        key={0}
        title={'Create a shop'}
        left={() => <IconButton icon={'creation'} mode="outlined" />}
        style={{padding: 10}}
        onPress={() => createShop.mutateAsync()}
      />
      <DragList
        renderItem={renderContent}
        keyExtractor={item => item?.id}
        style={{
          width: '100%',
          height,
          paddingBottom: 50,
        }}
        data={folderContent || []}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        scrollEnabled={true}
        onReordered={onReordered}
      />
    </ScrollView>
  );
}
